import React from "react";
import { Link } from "react-router-dom";
import "../css/legal.css";

const ConsentCheckbox = ({ checked, onChange }) => (
  <div className="consent-checkbox-group">
    <input
      type="checkbox"
      id="consent-terms"
      checked={checked}
      onChange={onChange}
      required
      aria-required="true"
    />
    <label htmlFor="consent-terms">
      I agree to the{" "}
      <Link to="/terms">Terms &amp; Conditions</Link>
      {" "}and{" "}
      <Link to="/privacy">Privacy Policy</Link>
    </label>
  </div>
);

export default ConsentCheckbox;